import { useEffect, useState } from "react";
import { adminApi, API } from "@/lib/api";
import { toast } from "sonner";
import { Download, Loader2, Mail, MapPin } from "lucide-react";

export default function Subscribers() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi.get("/admin/subscribers")
      .then((r) => setItems(r.data))
      .catch(() => toast.error("Falha ao carregar"))
      .finally(() => setLoading(false));
  }, []);

  const exportCsv = async () => {
    try {
      const res = await adminApi.get("/admin/subscribers/export", { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: "text/csv" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = "inscritos-rotta.csv";
      a.click();
      window.URL.revokeObjectURL(url);
      toast.success("CSV exportado");
    } catch { toast.error("Falha ao exportar"); }
  };

  return (
    <div className="space-y-6 sm:space-y-8" data-testid="admin-subscribers">
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <div className="flex items-center gap-3 text-[#C6A762] mb-3">
            <span className="gold-divider" />
            <span className="text-[11px] tracking-[0.35em] uppercase">Newsletter</span>
          </div>
          <h1 className="font-display text-3xl sm:text-4xl">Inscritos</h1>
          <p className="text-[#B8B8B8] mt-2 text-sm">{items.length} pessoa(s) na comunidade ROTTA.</p>
        </div>
        <button onClick={exportCsv} data-testid="export-csv" className="btn-gold px-5 py-3 rounded-full text-xs inline-flex items-center gap-2">
          <Download size={14} /> Exportar CSV
        </button>
      </div>

      {/* Desktop: table */}
      <div className="card-rotta overflow-x-auto hidden md:block">
        <table className="w-full text-sm min-w-[640px]">
          <thead className="bg-[#141414] text-[10px] tracking-[0.25em] uppercase text-[#7d7d7d]">
            <tr>
              <th className="text-left px-5 py-4 font-medium">Nome</th>
              <th className="text-left px-5 py-4 font-medium">E-mail</th>
              <th className="text-left px-5 py-4 font-medium">Cidade/Estado</th>
              <th className="text-left px-5 py-4 font-medium">Data</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={4} className="py-14 text-center text-[#7d7d7d]"><Loader2 className="inline animate-spin" size={16} /></td></tr>
            ) : items.length === 0 ? (
              <tr><td colSpan={4} className="py-14 text-center text-[#7d7d7d]">Nenhum inscrito ainda.</td></tr>
            ) : items.map((s) => (
              <tr key={s.id} className="border-t border-[#1a1a1a] hover:bg-white/[0.02]">
                <td className="px-5 py-4 text-white/90">{s.name || "—"}</td>
                <td className="px-5 py-4"><span className="inline-flex items-center gap-2 text-[#C6A762]"><Mail size={13} /> {s.email}</span></td>
                <td className="px-5 py-4 text-white/80">
                  {s.city_state ? (
                    <span className="inline-flex items-center gap-1"><MapPin size={12} className="text-[#C6A762]" /> {s.city_state}</span>
                  ) : "—"}
                </td>
                <td className="px-5 py-4 text-[#7d7d7d]">{s.created_at ? new Date(s.created_at).toLocaleDateString("pt-BR") : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile: cards */}
      <div className="md:hidden space-y-3">
        {loading ? (
          <div className="card-rotta p-8 text-center text-[#7d7d7d]"><Loader2 className="inline animate-spin" size={16} /></div>
        ) : items.length === 0 ? (
          <div className="card-rotta p-8 text-center text-[#7d7d7d] text-sm">Nenhum inscrito ainda.</div>
        ) : items.map((s) => (
          <div key={s.id} className="card-rotta p-4" data-testid={`subscriber-card-${s.id}`}>
            <div className="text-white font-medium truncate">{s.name || "—"}</div>
            <a href={`mailto:${s.email}`} className="mt-1 inline-flex items-center gap-2 text-[#C6A762] text-sm break-all">
              <Mail size={13} /> {s.email}
            </a>
            <div className="mt-3 flex items-center justify-between gap-2 text-xs">
              <span className="text-white/80 inline-flex items-center gap-1 truncate">
                {s.city_state ? <><MapPin size={12} className="text-[#C6A762] shrink-0" /> {s.city_state}</> : <span className="text-[#7d7d7d]">Sem cidade</span>}
              </span>
              <span className="text-[#7d7d7d] shrink-0">
                {s.created_at ? new Date(s.created_at).toLocaleDateString("pt-BR") : ""}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
void API;
